export const BUTTON_STATE_STYLE = {
  solid: {
    primary: 'hover:bg-primary-400 active:bg-primary-300 disabled:bg-gray-200',
    secondary:
      'hover:bg-secondary-400 active:bg-secondary-300  disabled:bg-gray-200',
    tertiary:
      'hover:bg-tertiary-400 active:bg-tertiary-300  disabled:bg-gray-200',
    light: 'hover:bg-light-400 active:bg-light-300  disabled:bg-gray-200',
    danger: 'hover:bg-danger-100 active:bg-danger-100  disabled:bg-gray-100',
    warning: 'hover:bg-warning-400 active:bg-warning-300  disabled:bg-gray-200',
    success: 'hover:bg-success-400 active:bg-success-300  disabled:bg-gray-200',
    medium: 'hover:bg-gray-200 active:bg-gray-300 disabled:bg-gray-200',
    dark: 'hover:bg-dark-400 active:bg-dark-300  disabled:bg-gray-200',
  },
  text: {
    primary: 'text-primary hover:bg-gray-100 active:bg-gray-200',
    secondary: 'text-secondary hover:bg-gray-100 active:bg-gray-200',
    tertiary: 'text-tertiary hover:bg-gray-100 active:bg-gray-200',
    light: 'text-light hover:bg-gray-100 active:bg-gray-200',
    danger: 'text-danger hover:bg-gray-100 active:bg-gray-200',
    warning: 'text-warning hover:bg-gray-100 active:bg-gray-200',
    success: 'text-success hover:bg-gray-100 active:bg-gray-200',
    medium: 'text-medium hover:bg-gray-100 active:bg-gray-200',
    dark: 'text-gray-800  hover:bg-gray-50 active:bg-gray-100',
  },
  outline: {
    primary:
      'border border-primary  text-primary hover:bg-primary-50 active:bg-primary-200',
    secondary:
      'border border-secondary text-secondary hover:bg-secondary-50 active:bg-secondary-200',
    tertiary:
      'border border-tertiary text-tertiary hover:bg-tertiary-50 active:bg-tertiary-200',
    light:
      'border border-light text-light hover:bg-light-50 active:bg-light-200',
    danger:
      'border border-danger text-danger hover:bg-danger-50 active:bg-danger-200',
    warning:
      'border border-warning text-warning hover:bg-warning-50 active:bg-warning-200',
    success:
      'border border-success text-success hover:bg-success-50 active:bg-success-200',
    medium:
      'border border-gray-300 text-gray-700 hover:bg-medium-50 active:bg-medium-200',
    dark: 'border border-dark text-dark hover:bg-dark-50 active:bg-dark-200',
  },
} as const;

export const BUTTON_STYLE = {
  solid: {
    primary: 'bg-primary text-white',
    secondary: 'bg-secondary text-white ',
    tertiary: 'bg-tertiary text-white ',
    light: 'bg-light text-white ',
    danger: 'bg-red-600 text-white ',
    warning: 'bg-warning text-white ',
    success: 'bg-success text-white ',
    medium: 'bg-gray-100 text-gray-800',
    dark: '',
  },
  text: {
    primary: 'text-primary',
    secondary: 'text-secondary',
    tertiary: 'text-tertiary',
    light: 'text-light',
    danger: 'text-danger',
    warning: 'text-warning',
    success: 'text-success',
    medium: 'text-medium',
    dark: 'text-gray-800 ',
  },
  outline: {
    primary: 'border border-primary text-primary',
    secondary: 'border border-secondary text-secondary',
    tertiary: 'border border-tertiary text-tertiary',
    light: 'border border-light text-light',
    danger: 'border border-danger text-danger',
    warning: 'border border-warning text-warning',
    success: 'border border-success text-success',
    medium: 'text-gray-700 bg-white',
    dark: 'border border-dark text-dark',
  },
} as const;

export const BUTTON_SIZE = {
  sm: ' p-2 text-xs rounded-xl ',
  md: 'px-3 py-2 text-base rounded-xl',
  lg: 'p-3 text-base rounded-xl',
  xl: 'p-4 text-lg rounded-2xl',
} as const;
